import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { siteConfig } from "../../siteConfig";
import { HeroOrganicBlobs } from "./HeroOrganicBlobs";
import { RoleSequence } from "./RoleSequence";
import { useHomeViewportLock } from "./useHomeViewportLock";

const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: siteConfig.name,
  jobTitle: "Full Stack AI Developer & Designer",
  url: siteConfig.baseUrl,
  email: siteConfig.email,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Nairobi",
    addressCountry: "KE"
  },
  sameAs: [
    siteConfig.social.github,
    siteConfig.social.linkedin,
    ...(siteConfig.social.twitter ? [siteConfig.social.twitter] : [])
  ]
};

export function HomeRoute() {
  useHomeViewportLock();

  return (
    <>
      <Helmet>
        <title>Leon Madara - Full Stack AI Developer &amp; Designer</title>
        <meta name="description" content="Full Stack AI Developer &amp; Designer based in Nairobi. Building web products, AI integrations, and data-driven interfaces." />
        <link rel="canonical" href={`${siteConfig.baseUrl}/`} />
        <meta property="og:title" content="Leon Madara - Full Stack AI Developer &amp; Designer" />
        <meta property="og:description" content="Full Stack AI Developer &amp; Designer based in Nairobi. Building web products, AI integrations, and data-driven interfaces." />
        <meta property="og:url" content={`${siteConfig.baseUrl}/`} />
        <meta property="og:image" content={siteConfig.defaultImage} />
        <meta property="og:image:alt" content={siteConfig.defaultImageAlt} />
        <meta name="twitter:title" content="Leon Madara - Full Stack AI Developer &amp; Designer" />
        <meta name="twitter:description" content="Full Stack AI Developer &amp; Designer based in Nairobi. Building web products, AI integrations, and data-driven interfaces." />
        <meta name="twitter:image" content={siteConfig.defaultImage} />
        <meta name="twitter:image:alt" content={siteConfig.defaultImageAlt} />
        <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
      </Helmet>
      <div className="page-content page-content--home">
      <section aria-label="Hero introduction" className="hero-section">
        <div className="hero-content">
          <p className="hero-intro-pill">
            <span aria-hidden="true">👋</span>
            <span>Hi there</span>
          </p>
          <p className="greeting">Hi, I&apos;m</p>
          <h1 className="name">Leon Madara</h1>
          <RoleSequence />
          <p className="description">
            I build high-performance digital products — clean code, considered
            design, shipped from Nairobi.
          </p>
          <div className="location-container">
            <div className="location-pin-wrapper">
              <svg
                aria-hidden="true"
                className="location-pin"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5Z" />
              </svg>
              <span className="pulse-ring" />
              <span className="pulse-ring" />
            </div>
            <p className="location">Nairobi, Kenya</p>
          </div>
          <div className="action-buttons">
            <Link className="btn-primary" to="/portfolio">
              View Projects
            </Link>
            <Link className="btn-secondary" to="/contact">
              Contact Me
            </Link>
          </div>
          <div aria-hidden="true" className="decorative-lines">
            <span className="line line-black" />
            <span className="line line-red" />
            <span className="line line-green" />
          </div>
        </div>
        <HeroOrganicBlobs />
        <div aria-hidden="true" className="decorative-shapes">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
        </div>
      </section>
    </div>
    </>
  );
}
